export default class TableChatData {

    static ChatTextList: { [key: string]: string; } = 
    {  
        "1" : "别吵了，别吵了，专心玩游戏吧",  
        "2" : "哈哈，这把你要惨了",
        "3" : "快点吧，不要耽误我赢钱",
        "4" : "快点吧，一会儿飞机都要起飞了",
        "5" : "快点快点，这把我要通杀",
        "6" : "你是哪里的我们交个朋友吧",
        "7" : "什么网啊！那么慢啊！",
        "8" : "怎么又断线了？",
    }







    


}
